import { render, staticRenderFns } from "./TeamsystemIntegratorListPage.vue?vue&type=template&id=4c0bf4e2"
import script from "./TeamsystemIntegratorListPage.vue?vue&type=script&lang=js"
export * from "./TeamsystemIntegratorListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports